import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, Router } from '@angular/router';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NGXLogger } from 'ngx-logger';
import { Unit } from '../models/unit/unit';
import { UnitService } from './unit.service';
import { User } from '../models/user/user';
import { LoadingService } from '../component/loading/loading.service';
import { ConfigService } from './config.service';
import { AlertService } from './alert.service';
import { LogService } from './log.service';
import { Error } from '../models/error/error';
var ApiService = /** @class */ (function () {
    function ApiService(http, router, logger, uservice, loadingService, config, alertService, logService) {
        this.http = http;
        this.router = router;
        this.logger = logger;
        this.uservice = uservice;
        this.loadingService = loadingService;
        this.config = config;
        this.alertService = alertService;
        this.logService = logService;
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
        this.host = this.config.config['api_base'] || '';
        this.buildNo = this.config.config['build'] || '';
        this.spaLog = (this.config.config['spa_log'] === 'true' ? true : false);
        this.isStop = false;
        this.errorHandler = null;
    }
    ApiService.prototype.makeUrl = function (path) {
        return "" + this.host + path;
    };
    ApiService.prototype.makeUrlWithParams = function (url, params) {
        if (params === void 0) { params = null; }
        var u = new DefaultUrlSerializer();
        var ut = u.parse(url);
        if (params !== null) {
            ut.queryParams = params;
        }
        return this.makeUrl(u.serialize(ut));
    };
    ApiService.prototype.execApi = function (params, url, rec, query) {
        this.logger.debug('action:', params);
        this.logger.debug('url:', url);
        this.logger.debug('request:', rec);
        this.logger.debug('query:', query);
        var options = new httpOptions();
        options.headers = this.headers;
        var losg = this.logService.getLog();
        if (this.spaLog && losg.length > 0) {
            options.headers = options.headers.append('x-pg-spa-log', btoa(unescape(encodeURIComponent(JSON.stringify(losg)))));
        }
        switch (params['type']) {
            case 'get':
                return this.get(url, query, options);
            case 'post':
                return this.post(url, rec, options);
            case 'put':
                return this.put(url, rec, options);
            case 'delete':
                return this.delete(url, options);
        }
    };
    ApiService.prototype.get = function (url, params, options) {
        var _this = this;
        if (params === void 0) { params = null; }
        if (options === void 0) { options = new httpOptions(); }
        var u = new DefaultUrlSerializer();
        var ut = u.parse(url);
        if (params !== null) {
            ut.queryParams = params;
        }
        options = this.setHttpOptions(options);
        this.loadingService.on();
        this.alertService.clear();
        return this.http.get(this.makeUrl(u.serialize(ut)), options).pipe(map(function (data) { return _this.extractData(data); }), catchError(function (err) { return _this.getErrorHandler()(err, _this); }));
    };
    ApiService.prototype.post = function (url, body, options) {
        var _this = this;
        if (options === void 0) { options = new httpOptions(); }
        options = this.setHttpOptions(options);
        this.loadingService.on();
        this.alertService.clear();
        return this.http.post(this.makeUrl(url), body, options).pipe(map(function (data) { return _this.extractData(data); }), catchError(function (err) { return _this.getErrorHandler()(err, _this); }));
    };
    ApiService.prototype.put = function (url, body, options) {
        var _this = this;
        if (options === void 0) { options = new httpOptions(); }
        options = this.setHttpOptions(options);
        this.loadingService.on();
        this.alertService.clear();
        return this.http.put(this.makeUrl(url), body, options).pipe(map(function (data) { return _this.extractData(data); }), catchError(function (err) { return _this.getErrorHandler()(err, _this); }));
    };
    ApiService.prototype.delete = function (url, options) {
        var _this = this;
        if (options === void 0) { options = new httpOptions(); }
        options = this.setHttpOptions(options);
        this.loadingService.on();
        this.alertService.clear();
        return this.http.delete(this.makeUrl(url), options).pipe(map(function (data) { return _this.extractData(data); }), catchError(function (err) { return _this.getErrorHandler()(err, _this); }));
    };
    ApiService.prototype.setHttpOptions = function (options) {
        if (typeof options.headers === 'undefined') {
            options.headers = this.headers;
        }
        options.withCredentials = true;
        return options;
    };
    ApiService.prototype.getCsrfToken = function () {
        var csrfToken = document.cookie.replace(/(?:(?:^|.*;\s*)csrfToken\s*\=\s*([^;]*).*$)|^.*$/, '$1');
        return { 'Csrf-Token': csrfToken };
    };
    ApiService.prototype.extractData = function (res) {
        this.checkBuildNo(res.headers);
        if (res.headers.has('x-pg-currentunit')) {
            var unit = JSON.parse(decodeURIComponent(escape(atob(res.headers.get('x-pg-currentunit')))));
            if (Unit.isUnit(unit)) {
                this.uservice.put(unit);
            }
        }
        if (res.headers.has('x-pg-currentuser')) {
            var user = JSON.parse(decodeURIComponent(escape(atob(res.headers.get('x-pg-currentuser')))));
            if (User.isUser(user)) {
                this.uservice.put(user);
            }
        }
        if (res.headers.has('x-pg-errcode')) {
            var err = JSON.parse(decodeURIComponent(escape(atob(res.headers.get('x-pg-errcode')))));
            if (Error.isCode(err)) {
                this.alertService.alert(err);
            }
        }
        this.loadingService.off();
        if (res.status == 303) {
            this.logger.debug('HttpResponse:', res);
            return this.router.navigate(['/']);
        }
        else if (res.status == 204) {
            return null;
        }
        return JSOG.decode(JSOG.encode(res.body));
    };
    ApiService.prototype.getErrorHandler = function () {
        this.loadingService.off();
        return this.errorHandler || this.handleError;
    };
    ApiService.prototype.handleError = function (error, self) {
        var errMsg;
        if (error instanceof HttpErrorResponse) {
            if (!self.checkBuildNo(error.headers)) {
                return throwError('different BuildNo.');
            }
            errMsg = '';
            try {
                errMsg = error.error;
            }
            catch (e) {
            }
            if (error.status == 401) {
                if (errMsg.code) {
                    self.alertService.alert(errMsg);
                }
                else {
                    self.onUnauthorized(errMsg);
                }
            }
        }
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        self.logger.error(errMsg);
        return throwError(errMsg);
    };
    ApiService.prototype.clearErrorHandler = function () {
        this.errorHandler = null;
    };
    ApiService.prototype.setErrorHandler = function (errorHandler) {
        this.errorHandler = errorHandler;
    };
    ApiService.prototype.onUnauthorized = function (errMsg) {
        this.alertService.alert(errMsg);
        localStorage.removeItem('currentUser');
        this.router.navigate(['/login']);
    };
    ApiService.prototype.checkBuildNoStr = function (buildNo) {
        if (buildNo) {
            return this.checkBuildNo(new HttpHeaders({ 'x-pg-spa-buildno': buildNo }));
        }
        return true;
    };
    ApiService.prototype.checkBuildNo = function (headers) {
        this.isStop = false;
        if (headers.has('x-pg-spa-buildno')) {
            var buildNo = headers.get('x-pg-spa-buildno');
            if (this.buildNo != buildNo) {
                this.logger.error('different BuildNo.');
                this.isStop = true;
                this.alertService.reload();
            }
        }
        return !this.isStop;
    };
    ApiService.prototype.getIsStop = function () {
        return this.isStop;
    };
    ApiService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ApiService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: Router },
        { type: NGXLogger },
        { type: UnitService },
        { type: LoadingService },
        { type: ConfigService },
        { type: AlertService },
        { type: LogService }
    ]; };
    return ApiService;
}());
export { ApiService };
var httpOptions = /** @class */ (function () {
    function httpOptions() {
        this.observe = 'response';
        this.responseType = 'json';
    }
    return httpOptions;
}());
//# sourceMappingURL=api.service.js.map